import axios from "axios";
import { config } from "../config.js";

let headers = { Accept: "application/json" };

export default axios.create({
    baseURL: config.server,
    headers: headers
  });